<template>
  <button type="submit"
    class="btn btn-wide btn-primary"
    v-bind:disabled="inSubmission"
    tabindex="1">
    <!-- hide if loading -->
    <span v-if="!inSubmission">
      <slot></slot>
    </span>

    <!-- show if loading -->
    <Spinner v-bind:isLoading="inSubmission" />
  </button>
</template>

<script>
import Spinner from '@/components/Spinner.vue';
/**
 * Submit Button
 *
 * A common submit button, useful for forms.
 */
export default {
  name: 'SubmitButton',
  components: {
    Spinner,
  },
  props: {
    /**
     * Determines if the form is being submitted to show
     * the loader icon
     */
    inSubmission: Boolean,
  },
};
</script>
